import { SlimEditorWrapper } from "@vericus/cadmus-editor-prosemirror";

import { ThreadFragment } from "@/generated/graphql";

interface Props {
  thread?: ThreadFragment;
}

export function PeerComment({ thread }: Props) {
  const commentContent = thread?.comments?.[0]?.content ?? null;

  return (
    <SlimEditorWrapper>
      <div
        className="ProseMirror"
        contentEditable="false"
        dangerouslySetInnerHTML={{ __html: commentContent || "" }}
      />
    </SlimEditorWrapper>
  );
}
